import { AsyncStatus } from 'lib-shared-legacy-types';
import { Channel } from 'lib-shared-types-channels';

import { useUserActiveBans } from './useUserActiveBans';

export type UseIsUserBannedOnChannelReturn = {
  isBanned: boolean;
  refreshStatus: () => void;
  asyncStatus: AsyncStatus;
};

export function useIsUserBannedOnChannel(
  userId: string | undefined,
  channel: Channel,
): UseIsUserBannedOnChannelReturn {
  const { bans, refreshItems, asyncStatus } = useUserActiveBans(userId);

  return {
    isBanned: bans.findIndex((ban) => ban.channel === channel) >= 0,
    refreshStatus: refreshItems,
    asyncStatus,
  };
}
